export const paymentsDeductions = [
    {label:'Title', name:'title'},
    {label:'Description', name:'description'},
    {label:'Amount', name:'amount', isNumber:true},
    {label:'Date', name:'date', isDate:true}
]
export const arrearsDeductions = []